import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import errorImage from "assets/notFound.png";
import "./styles.css";

const MENSAJE =
  "No pudimos cargar esta página. Revisa que tu navegador permita las cookies y los datos de sitio, o intenta abrir el enlace desde otro navegador.";

const ErrorFallback = () => {
  const error = useRouteError();

  useEffect(() => {
    console.error("🚀 error no controlado:", error);
  }, [error]);

  return (
    <div className="errorFallback">
      <div className="errorFallback_picture">
        <img
          className="errorFallback_picture_image"
          src={errorImage}
          width={184}
          height={191}
          alt=""
          aria-hidden="true"
        />
      </div>
      <div className="errorFallback_content">
        <h1 className="errorFallback_content_title">Ups… algo salió mal</h1>
        <p className="errorFallback_content_message">{MENSAJE}</p>
        <button
          className="errorFallback_content_button"
          type="button"
          onClick={() => window.location.reload()}
        >
          Volver a intentar
        </button>
      </div>
    </div>
  );
};

export default ErrorFallback;
